import React from 'react'

const Loading = () => {
    return (
        <div className='absolute top-0 left-0 w-full h-screen flex justify-center items-center z-50'>
            <span className="loader"></span>
        </div>
    )
}

export default Loading
